import type { NewDeclineNotificationConfig } from '../../../../domain/types/configs/company/NotificationConfig';

export const newDeclineNotificationConfig: NewDeclineNotificationConfig = {
  recipients: [
    {
      send: false,
      contact: "sonia.vanegas@dawipo.com",
      company: "FRESENIUS"
    },
    {
      company: "FRESENIUS",
      send: false,
      contact: "ap@cooweb.co"
    }
  ]
};